// Testing JIB
// export default {
// 	airBall1: {h: 44, w: 44, x: 0, y: 31},
// 	airBall2: {h: 44, w: 44, x: 0, y: 75},
// 	gate: {h: 115, w: 75, x: 44, y: 31},
// 	ball: {h: 44, w: 44, x: 0, y: 31},
// 	balls: {h: 83, w: 176, x: 119, y: 31},
// 	cloud: {h: 28, w: 92, x: 794, y: 31},
// 	jib: {h: 93, w: 69, x: 350, y: 28},
// 	jibLeftLeg: {h: 93, w: 69, x: 419, y: 31},
// 	jibRightLeg: {h: 93, w: 69, x: 488, y: 31},
// 	jibDuckLeftLeg: {h: 52, w: 93, x: 596, y: 31},
// 	jibDuckRightLeg: {h: 52, w: 93, x: 596, y: 85},
// 	ground: {h: 28, w: 2400, x: 0, y: 2},
// }

// Handball
export default window.app.sprite
